import * as actionTypes from './actionTypes'

import { db } from '../../firebase/firebase'

const USERNAME = 'ruppysuppy'
const BLOG_COUNT = 4

const getDataInit = () => {
    return {
        type: actionTypes.GET_DATA_INIT
    }
}

const getDataFail = (error) => {
    return {
        type: actionTypes.GET_DATA_FAIL,
        payload: {
            error: error
        }
    }
}

const getDataSuccess = (payload) => {
    return {
        type: actionTypes.GET_DATA_SUCCESS,
        payload: payload
    }
}

export const getData = () => {
    return async (dispatch) => {
        dispatch(getDataInit())
        try {
            const payload = {}
            const dataPromise = db.ref().once("value", (snapshot) => {
                snapshot.forEach((doc) => {
                    payload[doc.key] = doc.val()
                })
            })
            const blogsPromise = fetch(`https://dev.to/api/articles?username=${USERNAME}&per_page=${BLOG_COUNT}`)
            const [blogsResponse] = await Promise.all([blogsPromise, dataPromise])
            const blogsData = await blogsResponse.json()
            payload.blogs = blogsData;
            dispatch(getDataSuccess(payload))
        } catch (error) {
            dispatch(getDataFail(error.message))
        }
    }
}